<div class="detalhe-item">
  <p-tabs [value]="0">
    <p-tablist>
      <p-tab [value]="0">
        <span class="p-tabview-title">
          <span class="round-counter" [ngClass]="{ 'round-counter-empty': !data?.row_detalhe_pacote?.length }">{{
            data?.row_detalhe_pacote?.length ?? 0
          }}</span>
          Detalhes do pacote
        </span>
      </p-tab>
      <p-tab [value]="1">
        <span class="p-tabview-title">
          <span class="round-counter" [ngClass]="{ 'round-counter-empty': !data?.row_criticas_item?.length }">{{
            data?.row_criticas_item?.length ?? 0
          }}</span>
          Críticas do item
        </span>
      </p-tab>
      <p-tab [value]="2">
        <span class="p-tabview-title">
          <span class="round-counter" [ngClass]="{ 'round-counter-empty': !data?.row_motivos_rejeicao?.length }">{{
            data?.row_motivos_rejeicao?.length ?? 0
          }}</span>
          Motivos de rejeição do item
        </span>
      </p-tab>
    </p-tablist>
    <p-tabpanels>
    <p-tabpanel [value]="0">
      <ag-grid-angular
        #agGridDetalhePacote
        class="ag-theme-balham w-full"
        style="height: 200px"
        [rowData]="data?.row_detalhe_pacote"
        [gridOptions]="gridOptionsDetalhePacote"
      >
      </ag-grid-angular>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <ag-grid-angular
        #agGridCriticasItem
        class="ag-theme-balham w-full"
        style="height: 200px"
        [rowData]="data?.row_criticas_item"
        [gridOptions]="gridOptionsCriticasItem"
      >
      </ag-grid-angular>
    </p-tabpanel>

    <p-tabpanel [value]="2">
      <ag-grid-angular
        #agGridMotivosRejeicao
        class="ag-theme-balham w-full"
        style="height: 200px"
        [rowData]="data?.row_motivos_rejeicao"
        [gridOptions]="gridOptionsMotivosRejeicao"
      >
      </ag-grid-angular>
    </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
